import {SHOWANIMATIONFORM, HIDEANIMATIONFORM, SHOWFORMS} from '../types'

export const showForm = (name, title, value) => dispatch =>
  dispatch({type: SHOWANIMATIONFORM, name, title, value})
export const hideAnimationForm = () => dispatch => 
  dispatch({type: HIDEANIMATIONFORM})
export const showForms = () => dispatch =>
  dispatch({type: SHOWFORMS})